//'use strict';

export default function () {

	// Retrieve the performance object in a cross browser way. It is important to check window.performance first:
	window.performance = window.performance || window.mozPerformance || window.msPerformance || window.webkitPerformance || {};

	// Testa browser support för metoden som ska anv nedan:
	var navigation = window.performance.navigation || {};

	// Så här kan man också testa browser support, exempel:
	//function supports_history_api() {
	//	return !!(window.history && history.pushState);
	//}

	if (navigation
		&& navigation.type === navigation.TYPE_BACK_FORWARD
	)
	{
		// Om webbläsaren stödjer Navigation Timing API
		// OCH navigering till sidan skett medelst back/forward-knapparna:
		return true;
	}
	else
	{
		// Om webbläsaren inte stödjer Navigation Timing API
		// ELLER navigering skett på annat sätt än med back/forward-knapparna:
		return false;
	}
}
